import EditFormPage from "@Alternatives/Forms/Pages/EditFormPage.vue";
import FormsPage from "@Alternatives/Forms/Pages/FormsPage.vue";

export const routes = [

    //Manage Forms
    { path: "/portfolio/forms/:workspaceId/:projectId", component: FormsPage },
    { path: "/decision/forms/:workspaceId/:projectId",  component: FormsPage },

    //Edit Form
    { path: "/portfolio/edit-form/:workspaceId/:projectId/:formId", component: EditFormPage },
    { path: "/decision/edit-form/:workspaceId/:projectId/:formId", component: EditFormPage },
]
